module.exports = "<div id=\"tb-auth-callback-root\">\n    <span class=\"sr-only\">Logging In...</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/views/auth-callback/AuthCallback.tpl.html
// module id = n15j
// module chunks = 1